import React from 'react';
import { translate } from 'react-i18next';
import {
    Typography,
    InputAdornment,
    Checkbox,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Search, CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons';
import { getWorkplanCurrentStatusLabel } from '../../Enums/Helpers/LabellingHelper';
import './FilterSelectionBar.scss';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

function FilterSelectionBar(props) {
    const {
        setStatusFilterSelected, searchValue, setSearchValue, allStatus, t: translate
    } = props;
    const t = (prop) => translate(`workplanManager:common.${prop}`);

    return (
        <>
            <div className='fsb-container'>
                <div className="fsb-status-filter-container">
                    <Typography
                        component="p"
                        className="fsb-input-label"
                    >
                    {t('status')}
                    </Typography>
                    <Autocomplete
                        multiple
                        id="fsb-status-select"
                        className="fsb-status-multiple-select"
                        limitTags={1}
                        options={allStatus}
                        disableCloseOnSelect
                        getOptionLabel={(option) => getWorkplanCurrentStatusLabel(option)}
                        onChange={(event, values) => setStatusFilterSelected(values)}
                        defaultValue={allStatus}
                        renderOption={(option, { selected }) => (
                            <>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                    color="primary"
                                />
                                {getWorkplanCurrentStatusLabel(option)}
                            </>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                variant="outlined"
                                label=""
                            />
                        )}
                        renderTags={(value) => {
                            const numTags = value.length;

                            return (
                                <Typography variant="body2">
                                    {value
                                        .slice(0, 2)
                                        .map((option) => getWorkplanCurrentStatusLabel(option))
                                        .join(', ')}
                                    {numTags > 2 && ` +${numTags - 2} more`}
                                </Typography>
                            );
                        }}
                    />
                </div>
                <div className="fsb-search-bar-container">
                    <Typography
                        component="p"
                        className="fsb-input-label"
                    >
                        {t('search')}
                    </Typography>
                    <TextField
                        id="react-search-input"
                        size="small"
                        className='min-width-wp-searchBar'
                        variant="outlined"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        InputProps={{
                            startAdornment:
                                (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export default translate('workplanManager')(FilterSelectionBar);
